import { Box } from "@mui/material";
import LazyTable, {
  DEFAULT_ROWS_PER_PAGE,
  TableCellType,
  TableSortType,
} from "components/LazyTable";
import { useIntl } from "react-intl";

import SnackbarMessage from "components/SnackbarMessage";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AdminListRequestOfBaseFilter,
  BaseFilter,
  ListResponseOfOrganizationModel,
  OrganizationDetails,
} from "services/KnowfullyAdminClient";
import { SnackbarMessageProps } from "types/common-types";

interface OrganizationChildrenProps {
  organization: OrganizationDetails;
}

const OrganizationChildren = ({ organization }: OrganizationChildrenProps) => {
  const { formatMessage: t } = useIntl();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);

  const navigate = useNavigate();
  const { organizationService, organizationDetailsUrl } = useGlobalContext();

  const [order, setOrder] = useState<TableSortType>("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);

  const organizationChildren = useStrictQuery<ListResponseOfOrganizationModel>(
    ["organizations", organization, orderBy, order],
    () =>
      organizationService.getFirstLevelOrganizationChildren(
        AdminListRequestOfBaseFilter.fromJS({
          organizationId: organization.id,
          sortField: orderBy,
          sortDescending: order === "desc",
          parameters: BaseFilter.fromJS({}),
        })
      ),
    {
      keepPreviousData: true,
    }
  );
  const cells: Array<TableCellType> = [
    {
      accessor: "name",
      align: "left",
      width: 0,
      type: "text",
      label: t({ id: "nameLabel" }),
    },
    {
      accessor: "description",
      align: "left",
      width: 0,
      type: "text",
      label: t({ id: "descriptionLabel" }),
    },
  ];

  const onClick = (id: string) => {
    navigate(organizationDetailsUrl(id));
  };

  return (
    <Box>
      <LazyTable
        {...{
          rowCount: organizationChildren.data?.totalRecords ?? 0,
          rows: organizationChildren.data?.data ?? [],
          loading: organizationChildren.isFetching,
          dense: true,
          allowPagination: false,
          cells,
          page,
          setPage,
          order,
          setOrder,
          orderBy,
          setOrderBy,
          rowsPerPage,
          setRowsPerPage,
          onClick,
        }}
      />
      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </Box>
  );
};

export default withErrorBoundary(OrganizationChildren);
